import React, { useCallback, useRef } from 'react';
import { CircularProgress } from '@mui/material';
import BackgroundTile from 'features/room/settings/tabs/VideoBackgroundTab/BackgroundTile';
import Icon from 'components/Icon';
import { useTranslation } from 'react-i18next';

type CustomBackgroundUploadProps = {
  onSelect: (file: File) => void;
  isUploading?: boolean;
  disabled?: boolean;
};

const CustomBackgroundUpload = ({
  onSelect,
  isUploading = false,
  disabled = false,
}: CustomBackgroundUploadProps) => {
  const { t } = useTranslation('settings');

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onSelect(file);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleClick = useCallback(() => {
    if (!isUploading && !disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  }, [isUploading, disabled]);

  return (
    <BackgroundTile onClick={handleClick} bordered selected={false} disabled={disabled}>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
        disabled={isUploading}
      />
      {isUploading ? (
        <CircularProgress size={24} />
      ) : (
        <Icon name="image-add" aria-label={t('virtual_bg.aria_label_upload_bg')} />
      )}
    </BackgroundTile>
  );
};

export default CustomBackgroundUpload;
